module.exports = __webpack_public_path__ + "img/barry-pro.75ea44d2.jpg";